export default __webpack_public_path__ + "static/media/trash-icon.384b2409.svg";